<label class="uv-input-label">{{ label }} <span *ngIf="required">*</span></label>
<div
    *ngIf="mode === 'fancy'"
    class="select-wrapper"
    (click)="toggle()"
    [ngStyle]="{ width: width }"
    [class.select-wrapper-border]="hasBorder"
>
    <div class="select" [class.open]="open">
        <div class="select__trigger">
            <ng-content select="[title]"></ng-content>
            <uvx-icon>{{open ? 'arrow_expand' : 'expand_less'}}</uvx-icon>
        </div>
        <div class="custom-options flex flex-column">
            <ng-content select="[options]"></ng-content>
        </div>
    </div>
</div>

<div *ngIf="mode === 'input'" class="select-wrapper" (click)="toggle()" [ngStyle]="{ width: width }">
    <select class="select" [class.open]="open">
        <!-- <div class="select__trigger">
            <ng-content select="[title]"></ng-content>
            <uvx-icon [icon]="open ? 'arrow_expand' : 'expand_less'"></uvx-icon>
        </div> -->
        <!-- <div class="custom-options flex flex-column"> -->
        <ng-content></ng-content>
        <!-- <ng-content select="[options]"></ng-content> -->
        <!-- </div> -->
    </select>
</div>
